export const ErrorMessageConstants = {
  DEFAULT_ERROR: 'Sorry, something went wrong. Please try again later.',
};
